import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_ANALISTA_DE_SUPORTE: MapaCargo = 
{
  id: 'analista-de-suporte',
  titulo: 'Analista de Suporte',
  setor: 'Operações',
  secoes: [
    {
      id: 'responsabilidades',
      titulo: 'Responsabilidades',
      atividades: [
        'Atendimento ao cliente via whatsapp;',
        'Atendimento via plataforma de helpdesk;',
        'Reuniões on-line;',
        'Atribuições de chamados;',
        'Atendimento de chamados;',
        'Realização de testes nas lojas dos clientes.',
      ],
    },
  ],
}
